import axios from 'axios';
import { IVariety } from '../../../@types/model/masterData/variety/variety';
import { IVarietyUpsert } from '../../../@types/model/masterData/variety/varietyUpsert';
import { UpsertTypeEnum } from '../../../@types/enum/upsertType';

export default class VarietyHttpService {
    public static getList = async (lastSyncedTimeUnix : number, signal ?: AbortSignal) : Promise<Array<IVariety>> => {
        const result = await axios.get(`${API_URL}/v1/MasterData/Variety/GetList`, {
            params: {
                lastSyncedTimeUnix
            },
            signal
        });

        return result.data;
    }

    public static upsert = async (upsert : IVarietyUpsert, type : UpsertTypeEnum) : Promise<IVariety> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/Variety/${type}`, upsert);

        return result.data;
    }

    public static delete = async (id : number) : Promise<void> => {
        return await axios.delete(`${API_URL}/v1/MasterData/Variety/Delete`, {
            params: { id },
        });
    }
}